import { observable, action } from "mobx";
import { post } from "../services/ajax.service";

class NdcLookUpStore {

  @observable ndc_opportunities = [];
  @observable opportunity_details = [];
  @observable ndc_price_history = [];
  @observable url = "/api/v1/insightactions/ndclookup";
  @observable filterValue = "";


  @action sortby(filter) {
    this.filterValue=filter;
    if (this.ndc_opportunities.length > 0) {

      if (filter == "NDC") {
        this.ndc_opportunities = this.ndc_opportunities.sort(function (a, b) {
          if (a.NDC > b.NDC) return -1;
          if (a.NDC < b.NDC) return 1;
          return 0
        })
      } 
      if (filter == "GPI") {
        this.ndc_opportunities = this.ndc_opportunities.sort(function (a, b) {
          if (a.GPI > b.GPI) return -1;
          if (a.GPI < b.GPI) return 1;
          return 0
        })
      }  
      if (filter == "Strength") {
        this.ndc_opportunities = this.ndc_opportunities.sort(function (a, b) {
          if (a.strength > b.strength) return -1;
          if (a.strength < b.strength) return 1;
          return 0
        })
      } 
      if (filter == "Current AWP Unit Price") {
        this.ndc_opportunities = this.ndc_opportunities.sort(function (a, b) {
          if (parseFloat(a["Current AWP Unit Price"]) > parseFloat(b["Current AWP Unit Price"])) return -1;
          if (parseFloat(a["Current AWP Unit Price"])< parseFloat(b["Current AWP Unit Price"])) return 1;
          return 0
        })
      }       
      if (filter == "Total Package Qty") {
        this.ndc_opportunities = this.ndc_opportunities.sort(function (a, b) {
          if (parseFloat(a.total_package_qty) > parseFloat(b.total_package_qty)) return -1;
          if (parseFloat(a.total_package_qty) < parseFloat(b.total_package_qty)) return 1;
          return 0
        })
      }  
      
    }
  }



  @action get_ndc_opportunities = async data => {
    this.ndc_opportunities = [];
    try {
      let response = await post(
        `${this.url}/get_ndc_opportunities`,
        data
      );

      this.ndc_opportunities = response.data;
    } catch (err) {
      console.log(err);
    }
  };

  @action get_opportunity_details = async data => {
    this.opportunity_details = [];
    try {
      let response = await post(
        `${this.url}/get_opportunity_details`,
        data
      );

      this.opportunity_details = response.data;
      // console.log(JSON.stringify(this.opportunity_details));
    } catch (err) {
      console.log(err);
    }
  };

  @action get_ndc_price_history = async data => {
    this.ndc_price_history = [];
    try {
      let response = await post(
        `${this.url}/get_ndc_price_history`,
        data
      );

      this.ndc_price_history = response.data;
    } catch (err) {
      console.log(err);
    }
  }


}

export default NdcLookUpStore;
